import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelectLanguage } from '../../hooks/global/Languages';

export default function MultiSelect({ value, question, onChange, sourceId }) {
    const { t, i18n } = useTranslation();
    const lng = i18n.language.toUpperCase();
    const id = question.id + "" + sourceId;

    const { selectTextByLanguage } = useSelectLanguage();

    const [selectedAnswers, setSelectedAnswers] = useState([]);

    const handleMultiSelectAnswer = (question, answer, checked) => {
        let updatedSelectedAnswers;

        if (checked) {
            updatedSelectedAnswers = [...selectedAnswers, answer];
        } else {
            updatedSelectedAnswers = selectedAnswers.filter((ans) => ans.value !== answer.value);
        }

        // Assign order if there are selected answers
        if (updatedSelectedAnswers.length > 0) {
            updatedSelectedAnswers[0].order = question.order;
        }

        setSelectedAnswers(updatedSelectedAnswers);
        onChange?.(question, updatedSelectedAnswers);
    };

    return (
        <div className="reviewInvite-customMultiselect">
            <div className="reviewInvite-question clearfix">
                <h3>{question.text[lng]}</h3>

                {Array.isArray(question.answer) && question.answer.map((answer, index) => {
                    const isChecked = selectedAnswers.some((ans) => ans.value === answer.value);
                    return (
                        <div key={index + answer.value}>
                            <input
                                type="checkbox"
                                id={id + answer.value + index}
                                checked={isChecked}
                                onChange={(event) => handleMultiSelectAnswer(question, answer, event.target.checked)}
                            />
                            <label htmlFor={id + answer.value + index}>{selectTextByLanguage(answer.text, lng)}</label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
